<template>
  <NewsCenter :rootId="NEWS_ROOT_ID" :columnTree="columnTree" />
</template>

<script>
import NewsCenter from './NewsCenter.vue'
import { api, deptId } from '../config'

// 固定的"新闻"主栏目ID
const NEWS_ROOT_ID = 1599

export default {
  name: 'NewsPage',
  components: { NewsCenter },
  data() {
    return {
      // 新闻主栏目 ID（透传给 NewsCenter）
      NEWS_ROOT_ID,
      // 完整栏目树（由本页面请求后传给 NewsCenter）
      columnTree: []
    }
  },
  created() {
    this.fetchColumnList()
  },
  methods: {
    // 拉取完整栏目列表并组装成树
    fetchColumnList() {
      let that = this
      that.$axios
        .post(
          api + '/site/columnList',
          { deptId: deptId },
          { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
        )
        .then(function (res) {
          if (res.data && res.data.code === 0 && res.data.data) {
            that.columnTree = that.buildTree(res.data.data)
          } else {
            that.columnTree = []
          }
        })
        .catch(function () {
          that.columnTree = []
        })
    },
    // 将扁平的栏目数据组装为树
    buildTree(data) {
      const config = { id: 'menuId', parentId: 'parentId', childrenList: 'children' }
      const childrenListMap = {}
      const nodeIds = {}
      const tree = []
      for (let d of data) {
        const pId = d[config.parentId]
        if (childrenListMap[pId] == null) childrenListMap[pId] = []
        nodeIds[d[config.id]] = d
        childrenListMap[pId].push(d)
      }
      for (let d of data) {
        const pId = d[config.parentId]
        if (nodeIds[pId] == null) tree.push(d)
      }
      const adapt = o => {
        if (childrenListMap[o[config.id]] !== null && childrenListMap[o[config.id]] !== undefined) {
          o[config.childrenList] = childrenListMap[o[config.id]]
        }
        if (o[config.childrenList]) {
          for (let c of o[config.childrenList]) adapt(c)
        }
      }
      for (let t of tree) adapt(t)
      return tree
    }
  }
}
</script>
